/* import __COLOCATED_TEMPLATE__ from './taxonomy-manager.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { TrackedAsyncData } from 'ember-async-data';
import { restartableTask, timeout } from 'ember-concurrency';
import { filter } from 'rsvp';
import escapeRegExp from 'ilios-common/utils/escape-reg-exp';
let TaxonomyManager = (_class = class TaxonomyManager extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "flashMessages", _descriptor3, this);
    _initializerDefineProperty(this, "termFilter", _descriptor4, this);
    _initializerDefineProperty(this, "vocabulary", _descriptor5, this);
    _defineProperty(this, "setTermFilter", _buildTask(() => ({
      context: this,
      generator: function* (termFilter) {
        const clean = escapeRegExp(termFilter);
        if (isPresent(clean)) {
          yield timeout(250);
        }
        this.termFilter = clean;
      }
    }), null, "setTermFilter", "restartable"));
  }
  get filteredTopLevelTermsData() {
    return new TrackedAsyncData(this.getFilteredTopLevelTermsFromSelectedVocabulary(this.selectedVocabulary, this.termFilter));
  }
  get filteredTopLevelTerms() {
    return this.filteredTopLevelTermsData.isResolved ? this.filteredTopLevelTermsData.value : [];
  }
  async getFilteredTopLevelTermsFromSelectedVocabulary(vocabulary, termFilter) {
    if (!vocabulary) {
      return [];
    }
    const terms = await vocabulary.getTopLevelTerms();
    if (termFilter) {
      const exp = new RegExp(termFilter, 'gi');
      return await filter(terms, async term => {
        const searchString = await term.getTitleWithDescendantTitles();
        return searchString.match(exp);
      });
    }
    return terms;
  }
  get terms() {
    return this.filteredTopLevelTerms ?? [];
  }
  get nonEmptyVocabularies() {
    if (!this.args.vocabularies) {
      return [];
    } else {
      return this.args.vocabularies.filter(vocab => {
        return vocab.termCount > 0;
      });
    }
  }
  get assignableVocabularies() {
    return this.nonEmptyVocabularies.filter(vocab => vocab.active);
  }
  get listableVocabularies() {
    return this.nonEmptyVocabularies.filter(vocab => {
      if (vocab.active) {
        return true;
      }
      const terms = this.args.selectedTerms;
      let hasTerms = false;
      terms.forEach(term => {
        if (term.belongsTo('vocabulary').id() === vocab.id) {
          hasTerms = true;
        }
      });
      return hasTerms;
    });
  }
  get selectedVocabulary() {
    if (this.vocabulary) {
      return this.vocabulary;
    }
    if (this.args.vocabulary) {
      return this.args.vocabulary;
    }
    if (this.assignableVocabularies.length) {
      return this.assignableVocabularies[0];
    }
    return null;
  }
  get selectedVocabularyId() {
    return this.selectedVocabulary?.id;
  }
  changeSelectedVocabulary(event) {
    const vocabId = event.target.value;
    this.vocabulary = this.assignableVocabularies.find(v => {
      return v.id === vocabId;
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "termFilter", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "vocabulary", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "filteredTopLevelTermsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "filteredTopLevelTermsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeSelectedVocabulary", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeSelectedVocabulary"), _class.prototype), _class);
export { TaxonomyManager as default };